// Shared types for the p5.nanokontrol2 library.
export {};
